import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {
  GetCategoryAPI,
  AddCategoryAPI,
  UpdateCategoryAPI,
} from "./CategoryAPI";

export interface CloudState {
  getData: any;
  addData: any;
  updateData: any;
  error: any;
  isLoading: boolean;
  status: "idle" | "pending" | "success" | "error";
}

const initialState: CloudState = {
  getData: undefined,
  addData: undefined,
  updateData: undefined,
  error: undefined,
  isLoading: false,
  status: "idle",
};

export const GetCategoryListAsync = createAsyncThunk(
  "category/Get",
  async () => {
    const Response = await GetCategoryAPI();
    return Response;
  }
);

export const AddDataAsync = createAsyncThunk(
  "category/Add",
  async (data: any) => {
    const Response = await AddCategoryAPI(data);
    return Response;
  }
);

export const UpdateDataAsync = createAsyncThunk(
  "category/Update",
  async (data: any) => {
    const Response = await UpdateCategoryAPI(data);
    return Response;
  }
);

export const CategorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCategoryListAsync.pending, (state) => {
        state.isLoading = true;
        state.status = "pending";
      })
      .addCase(GetCategoryListAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "error";
        state.error = action.error;
      })
      .addCase(GetCategoryListAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.getData = action.payload;
      })

      .addCase(AddDataAsync.pending, (state) => {
        state.isLoading = true;
        state.status = "pending";
      })
      .addCase(AddDataAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "error";
        state.error = action.error;
      })
      .addCase(AddDataAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.addData = action.payload;
      })

      .addCase(UpdateDataAsync.pending, (state) => {
        state.isLoading = true;
        state.status = "pending";
      })
      .addCase(UpdateDataAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "error";
        state.error = action.error;
      })
      .addCase(UpdateDataAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.updateData = action.payload;
      });
  },
});

export const {} = CategorySlice.actions;

export const AddCategoryData = (state: RootState) => {
  return state.category.addData;
};

export const UpdateCategoryData = (state: RootState) => {
  return state.category.updateData;
};

export const GetCategoryList = (state: RootState) => {
  return state.category.getData;
};

export const LoadingData = (state: RootState) => {
  return state.category.isLoading;
};

export const StatusData = (state: RootState) => {
  return state.category.status;
};

export const categoryReducer = CategorySlice.reducer;
